import { Markdown } from "@/components/ai/chat/Markdown";
import { useProgressiveText } from "@/hooks/use-progressive-text";
import type { AgentMessageFragmentText } from "@/hooks/use-stream-conversation";
import { type FC } from "react";

export const FragmentText: FC<{
    fragment: AgentMessageFragmentText;
}> = ({ fragment }) => {
    const { text } = useProgressiveText(fragment.content, { speed: 10 });
    return (
        <div data-completed={fragment.completed}>
            <Markdown content={fragment.completed ? fragment.content : text} />
        </div>
    );
};
